module.exports = __webpack_public_path__ + "fonts/Euclid Circular B SemiBold Italic.e8e7e771.woff";